"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable max-lines */
const react_1 = __importDefault(require("react"));
exports.default = {
    general: {
        email: 'Email',
        thereWasAnError: 'There was an error processing your request.',
        inactiveAccount: 'Account inactive',
        inactiveAccountDescription: 'Sorry, your account is inactive. Please call an administrator.',
        password: 'Password',
        close: 'close',
        loading: 'Loading',
        okay: 'Okay',
        enterHere: 'Enter Here',
        next: 'Next',
        back: 'Back',
        home: 'Home',
        finish: 'Finish',
        underConstructionDescription: "This page is currently under construction",
        pageNotFoundTitle: "Page not found",
        pageNotFound: "We can’t seem to find the page you’re looking for.",
        goBack: "Go back",
        enterCorrectUrl: "URL is not valid",
        phoneNumberNotValid: "Phone number is not valid",
        pleaseDontClose: "Please don't close this window.",
        saving: "Saving",
        required: "This field is required.",
        loading2: "Loading...",
    },
    home: {
        greetings: 'Greetings',
        niceToSeeYou: (name) => `Nice to see you ${name}`,
        clickToReplaceName: 'Click to replace name',
    },
    login: {
        helmetTitle: "Summithill / Login",
        pleaseEnterAValid: 'Please enter a valid email address.',
        incorrectPassword: 'Incorrect password.',
        welcomeBack: 'Welcome Back',
        enterEmail: 'Email',
        enterPassword: 'Password',
        welcome: 'Welcome to ClearSummit',
        signIn: 'Login',
        signUp: 'Sign Up',
        logOut: "Log Out",
        description: 'Log in to your account to use our amazing features.',
        forgotPassword: 'Forgot Password?',
        dontHaveAnAccount: "Don't Have An Account?",
        callUs: "Call us to register for an account",
        phoneNumber: "(804) 525-9292",
        phoneNumberRaw: "8045259292",
        privacyPolicy: "Privacy Policy",
    },
    signup: {
        pleaseEnterAValidEmail: 'Please enter a valid email address.',
        passwordsDoNotMatch: 'Passwords do not match.',
        beAtLeast8: 'Be at least 8 characters',
        notExceed50: 'Not exceed 50 characters',
        containAtLeast1Number: 'Contain at least one number',
        containAtLeast1Special: 'Contain at least one special character',
        welcomeToClearSummit: 'Welcome to ClearSummit',
        createAccount: 'Create a free account to use our amazing features.',
        signUpToGet: 'Sign up to get started',
        passwordMustBe: 'Password must be 8 characters and contain at least one letter, one number and one special character.',
        confirmPassword: 'Confirm Password',
        getStarted: 'Get Started!',
        inputEmail: 'Input Email Here',
        iAcceptThe: 'I accept ClearSummit’s ',
        termsAndConditions: 'Terms and Conditions of Use.',
        firstName: 'First Name',
        lastName: 'Last Name',
        username: 'username',
        email: 'Email*',
        password: 'Password*',
        signUp: 'Sign Up',
        alreadyHaveAnAccount: 'Already have an account? ',
        login: 'Login',
    },
    resetPassword: {
        title: 'Create a new password',
        description: 'Enter your new password below. Use at least 8 characters. Your can use uppercase, lowercase and symbols.',
        forgotYourPassword: 'Forgot Your Password?',
        pleaseEnterYourEmail: 'Please enter your email below to receive your password reset instructions.',
        ifYouHaveAnAccount: 'If you have an account, a reset link was sent to your email.',
        resetYourPassword: 'Reset Your Password',
        pleaseEnterYourNewPassword: 'Enter your new password below. Use at least 8 characters. Your can use uppercase, lowercase and symbols.',
        resetPassword: 'Reset Password',
        passwordChangedSuccessfully: 'Password changed successfully please log in to continue',
        enterNewPassword: 'New Password',
        confirmNewPassword: 'Confirm Password',
        sendMeInstructions: "Send me the instructions",
        saveNewPassword: 'Save new password',
        rememberIt: "Already remembered it?",
        login: "Login",
        helmetTitle: "Summithill / Reset Password"
    },
    passwordCreation: {
        enterNewPassword: 'Password',
        saveNewPassword: 'Save password',
        helmetTitle: "Summithill / Create Password",
        description: "We’re glad to have you! Please create a password to start.",
        passwordCreated: "Your password was created",
        youCanLogin: "You can now login to your account."
    },
    changePassword: {
        oldPassword: 'Old Password',
        newPassword: 'New Password',
        confirmPassword: 'Confirm Password',
        changePassword: 'Change Password',
        passwordCreated: "Your password was created",
        youCanLogin: "You can now login to your account."
    },
    instructions: {
        title: 'Instructions sent!',
        description: 'If you have a Summit Hill account, you will recieve a reset link with instructions to create a new password.',
        goBackToSignIn: 'Go back to sign in',
        helmetTitle: "Summithill / Reset Password Instructions"
    },
    verifyEmail: {
        verifyEmail: 'Verify email address',
        weveSentAnEmailToVerify: `We've sent an email to verify your address.  Please check your email and follow the link.`,
        resendEmail: 'Resend email'
    },
    verifyEmailConfirm: {
        verifyEmailAddress: 'Verify email address',
        thanksforValidatingYourEmail: `Thanks for validating your email.`,
    },
    changePasswordSuccess: {
        changePasswordConfirmation: 'Change Password Confirmation',
        youveHaveSuccessfullyChanged: 'You have successfully changed your password.',
    },
    header: {
        logout: "Logout",
        profile: "Profile"
    },
    footer: {
        program: "Program",
        support: "Support",
        profile: "Profile"
    },
    profile: {
        helmetTitle: "Summithill / Profile",
        logout: "Log out",
        profile: "Profile",
        personalInformation: "Personal information",
        name: "Name",
        email: "Email address",
        phone: "Phone",
        therapistInformation: "Therapist information",
        noTherapist: "We are working on assigning you a Therapist.",
        caseManagerInformation: "Case Manager information",
        noCaseManager: "We are working on assigning you a Case Manager."
    },
    program: {
        helmetTitle: "Summithill / Program",
        sectionStatus: (completedCount, totalCount) => `${completedCount} of ${totalCount} completed`,
        videoDurationInfo: ({ hours, minutes, seconds }) => {
            const durationInfo = ['Video', '·'];
            if (hours > 0) {
                durationInfo.push(`${hours}hr`);
            }
            if (minutes > 0) {
                durationInfo.push(`${minutes}min`);
            }
            if (seconds > 0) {
                durationInfo.push(`${seconds}s`);
            }
            return durationInfo.join(' ');
        },
        questionsCount: (count) => `Questions · ${count} ${count > 1 ? 'questions' : 'question'}`,
        questionsOf: (current, total) => `Question ${current} of ${total}`,
        processQuestions: "Process Questions",
        processQuestionsDescription: "Please complete the process questions in order to unlock the following modules.",
        sessionType: {
            caseManagement: 'Case Management Session',
            therapy: 'Therapy Session',
        },
        bookSessionType: {
            caseManagement: 'Book a Case Management Session',
            therapy: 'Book a Therapy Session',
        },
        previous: 'Previous',
        summary: 'Summary',
        myAnswers: 'My answers',
        hereIsASummary: 'Here’s a summary of your answers. Please read and confirm them before submitting.',
        rememberThatOnce: 'Remember that once submitted, answers can’t be modified.',
        greatJob: 'Great job!',
        submit: 'Submit',
        thanksForSubmitting: 'Thanks for submitting your answers.',
        continueToTheNext: 'Continue to the next section',
        checkyAnswers: 'Check my answers',
        youHaveCompleted: 'You have successfully completed the process questions for this module.',
        pleaseBookYourTherapy: 'Please book your therapy session and wait for your therapist to unlock the following modules.',
        pleaseBookYourCaseManagement: 'Please book your case management session and wait for your case manager to unlock the following modules.',
        bookOrReschedule: 'Book or Reschedule',
        youHaveDoneAGreatJob: 'You have done a great job!',
        done: "Done",
        timeToBook: {
            caseManagement: 'It’s time for you to book your Case Management session.',
            therapy: 'It’s time for you to book your Therapy session.',
        },
        cantContinue: 'You won’t be able to continue with the course until having the session, but you can always go back and check all the content you have watched.',
        noOneAssigned: {
            caseManagement: 'We are working on assigning you a Case Manager.',
            therapy: 'We are working on assigning you a Therapist.',
        },
        tryAgainLater: 'Please try again later.',
        therapistInfo: 'Here’s the therapist info:',
        info: {
            caseManagement: "Here’s the manager info:",
            therapy: "Here’s the therapist info:"
        },
        name: "Name: ",
        email: "Email: ",
        phone: "Phone: ",
        meetingLink: 'Meeting link: ',
        iUnderstand: 'I understand',
        finish: 'Finish',
        completeNow: 'Complete Now',
        completedTherapySession: 'Therapy session completed!',
        completedTherapySessionText: 'Congratulations! You have completed your therapy session and unlocked the following modules.',
        comepletedCaseManagement: 'Case management session completed!',
        comepletedCaseManagementText: 'Congratulations! You have completed your case management session and unlocked the following modules.',
    },
    support: {
        helmetTitle: "Summithill / Support",
        support: "Support",
        message: "Message",
        sendAMessage: "Send a message",
        title: {
            technical: 'Technical Support',
            clinical: 'Clinical support'
        },
        pleaseContact: {
            technical: "Please contact us if you are having any technical issues such as not being able to play videos.",
            clinical: "Please let us know if you need help from our clinical staff.",
        },
        messageTitle: {
            technical: "Message Technical support",
            clinical: "Message Clinical support"
        },
        typeYourMessage: "Type your message here",
        thanksForYourFeedback: "Thanks for your feedback",
        wellContactYou: "We’ll contact you as soon as possible.",
        send: "Send",
        mail: "Mail"
    },
    paywall: {
        sessions: {
            helmetTitle: "Summithill / Ready to start",
            readyToStart: (showPaywall) => `Ready to ${showPaywall ? 'start' : 'continue'}?`,
            // eslint-disable-next-line max-len
            descriptionStart: (sessionPrice) => react_1.default.createElement("p", null,
                "Each session costs ",
                react_1.default.createElement("strong", null,
                    "$",
                    sessionPrice,
                    "*"),
                " and includes one therapy or case management session and 6 modules. Pick how many sessions you would like to purchase:"),
            descriptionEnd: react_1.default.createElement("p", null, "*Please note that price is calculated based on insurance coverage at the time of enrollment.")
        },
        payment: {
            helmetTitle: "Summithill / Payment details",
            paymentDetails: 'Payment details',
            back: "Back",
            congratulations: 'Congratulations!',
            oops: 'Oops!',
            successfullyActivatedProgram: 'You have successfully activated your program.',
            declinedPayment: 'Looks like your payment was declined. Please try again.',
            letsStart: "Let's start",
            retry: 'Retry',
            processingPayment: 'Processing payment',
            paymentsAreSecured: 'Payments are secured and encrypted.'
        },
        banner: {
            keepUp: "Keep up the good work!",
            toUnlock: "To unlock the following program modules and your next therapy or case management session, click the continue button to proceed.",
            continue: "Continue"
        }
    },
    manageAccounts: {
        helmetTitle: "Summithill / Manage Accounts",
        pageTitle: "Manage Accounts",
        searchByName: "Search by name, email...",
        filters: "Filters",
        bulkActions: "Bulk Actions",
        addNewUser: "Add new User",
        selectOneRole: "Select one role",
        selectOneStatus: "Select one status",
        role: "Role",
        status: "Status",
        allRoles: "All roles",
        admin: "Admin",
        patient: "Patient",
        caregiver: "Caregiver",
        allStatus: "All status",
        active: "Active",
        inactive: "Inactive",
        name: "Name",
        emailAddress: "Email address",
        actions: "Actions",
        resendInvite: "Resend invite",
        markAsInactive: "Mark as Inactive",
        markAsActive: "Mark as Active",
        youMarkedStatus: (usersCount, status) => react_1.default.createElement("p", null,
            "You marked ",
            react_1.default.createElement("strong", null,
                usersCount,
                " users"),
            " as ",
            status),
        invitesSuccess: "Invites have been sucessfully sent.",
        create: {
            helmetTitle: "Summithill / Add new user",
            pageTitle: "Add new user",
            backToAccounts: "Back to accounts",
            backToPrograms: "Back to list",
            cancel: "Cancel",
            save: "Save",
            generalInformation: "General Information",
            firstName: "First Name*",
            lastName: "Last Name*",
            email: "Email*",
            phone: "Phone",
            phoneNumberOptional: "Phone number (Optional)",
            permissions: "Permissions",
            role: "Role",
            userStatus: "User Status",
            program: "Program",
            calendarUrl: "Calendar URL",
            meetingUrl: "Meeting URL",
            caregivers: "Caregivers",
            caseManager: "Case manager",
            therapist: "Therapist",
            selectACaseManager: "Select a Case manager",
            selectATherapist: "Select a Therapist",
            caseManager2: "Case manager",
            therapist2: "Therapist",
            active: "Active",
            inactive: "Inactive",
            sessionPrice: "Cost per session",
            totalPaidSessions: "Total paid sessions",
            caregiverType: "Caregiver type",
            successfullyAdded: (userFullName) => react_1.default.createElement("p", null,
                react_1.default.createElement("strong", null, userFullName),
                " was successfully added"),
            savingAccount: "Saving account",
        },
        detail: {
            helmetTitle: "Summithill / Edit user",
            pageTitle: "Edit user",
            backToAccounts: "Back to accounts",
            backToPrograms: "Back to list",
            cancel: "Cancel",
            save: "Save",
            delete: "Delete",
            generalInformation: "General Information",
            firstName: "First Name*",
            lastName: "Last Name*",
            email: "Email*",
            phone: "Phone",
            phoneNumberOptional: "Phone number (Optional)",
            permissions: "Permissions",
            role: "Role",
            userStatus: "User Status",
            program: "Program",
            calendarUrl: "Calendar URL",
            meetingUrl: "Meeting URL",
            caregivers: "Caregivers",
            caseManager: "Case manager",
            therapist: "Therapist",
            selectACaseManager: "Select a Case manager",
            selectATherapist: "Select a Therapist",
            caseManager2: "Case manager",
            therapist2: "Therapist",
            active: "Active",
            inactive: "Inactive",
            sessionPrice: "Cost per session",
            totalPaidSessions: "Total paid sessions",
            caregiverType: "Caregiver type",
            successfullyUpdated: (userFullName) => react_1.default.createElement("p", null,
                react_1.default.createElement("strong", null, userFullName),
                " has been successfully updated"),
            successfullyDeleted: (userFullName) => react_1.default.createElement("p", null,
                "You have successfully deleted ",
                react_1.default.createElement("strong", null, userFullName),
                " account."),
            savingAccount: "Saving account",
            deleteThisUser: "Delete this user",
            deleteDescription: (userFullName) => react_1.default.createElement("p", null,
                "Are you sure you want to delete ",
                react_1.default.createElement("strong", null, userFullName),
                " account? All related information will be lost."),
            resendInvite: "Resend invite"
        }
    },
    managePrograms: {
        helmetTitle: "Summithill / Manage Programs",
        pageTitle: "Manage Programs Page",
        title: "Manage Programs",
        searchPlaceholder: "Search by program name...",
        addNewProgram: "Add new program",
        tableColumnName: "Program name",
        deleteProgram: "Delete program",
        create: {
            name: "Name",
            newProgram: "New Program",
            cancel: 'Cancel',
            save: 'Save',
            programName: "Program name",
            programNamePlaceholder: "Enter the program name",
            videoLabel: "Video",
            processQuestionLabel: "Process question",
            processQuestionPlaceholder: "Process question name",
            videoUrl: "URL",
            videoName: "Video name",
            videoDuration: "Duration",
            videoDurationPlaceholder: "00:00:00",
            question: "Question",
            questionPlaceholder: "Placeholder",
            addNewQuestion: "Add new question",
            addNewStep: "Add new step",
            addNewSection: "Add new section",
            delete: "Delete",
            sectionTypeSession: "Session",
            sectionTypeContent: "Content",
            sessionTypeTherapy: "Therapy",
            sessionTypeCaseManagement: "Case Management",
            selectSession: "Select a session type",
            selectStep: "Select a step",
            selectSection: "Select a section type",
            expand: "Expand Section",
            collapse: "Collapse Section",
            deleteThisSection: "Delete this section",
        },
        detail: {
            deleteProgram: "Delete Program",
            areYouSureYouWantToDelete: (programName) => react_1.default.createElement("p", null,
                "Are you sure you want to delete ",
                react_1.default.createElement("strong", null, programName),
                "? All related information will be lost and patients will lose access to this program."),
            cancel: "Cancel",
            delete: "Delete",
            deleteSection: "Delete Section",
            areYouSureYouWantToDeleteSection: (sectionName) => react_1.default.createElement("p", null,
                "Are you sure you want to delete ",
                react_1.default.createElement("strong", null, sectionName),
                "? All related information will be lost and patients will lose access to this section."),
            deleteThisProgram: "Delete this program",
            programSuccessfullyDeleted: "Program successfully deleted",
            programSuccessfullyCreated: "Program successfully created",
            sectionSuccessfullySaved: (name) => `Section ${name} was successfully saved`,
            sectionSuccessfullyDeleted: "Section successfully deleted",
        }
    },
    patientProgress: {
        helmetTitle: "Summithill / Patient Progress",
        pageTitle: "Patient Progress",
        searchByName: "Search by name, email...",
        filters: "Filters",
        selectOneProgram: "Select one program",
        program: "Program",
        selectOneSection: "Select on section",
        section: "Section",
        name: "Name",
        emailAddress: "Email address",
        currentStep: "Current step",
        dateCompleted: "Date completed",
        detail: {
            helmetTitle: "Summithill / Patient Progress",
            pageTitle: "Patient Progress Detail",
            backToList: "Back to list",
            sectionUpdated: "Section has been successfully updated",
            contentUpdated: "Content has been successfully updated",
            questions: {
                helmetTitle: "Summithill / Process Questions",
                title: (firstName) => `${firstName}'s answers`,
                questionNumber: (index, total) => `Question ${index} of ${total}`,
                backToProgressList: "Back to progress list"
            }
        },
        therapyNote: {
            helmetTitle: "Summithill / Therapy Note",
            pageTitle: (sessionType) => `Add ${sessionType === "THERAPY" ? "therapy" : "case management"} notes`,
            backToPatientProgress: "Back to progress list",
            date: "Date and time*",
            time: "Time*",
            attitudeBehavior: "Attitude/behavior",
            mood: "Mood",
            affect: "Affect",
            speech: "Speech",
            thoughtProcess: "Thought process",
            cognition: "Cognition",
            insight: "Insight",
            presentinIssueKeyStressOrEvent: "Presenting Issue/Key Stressor or Event",
            reviewDiscussionOfRecoveryEnvironment: "Review/Discussion of recovery environment",
            reportedCravingsUsingDreamsSleepQualityEatingAppetite: "Reported cravings, using dreams, sleep quality, eating/appetite",
            interventionProvidedToday: "Intervention provided today",
            clientResponseToIntervention: "Client response to intervention",
            planOrGoalForNextSession: "Plan or goal for next session",
            necessityForContinuedLevelOfCare: "Necessity for continued level of care",
            additionalTherapistNotesOrProgressTowardsGoals: "Additional therapist notes or progress towards goals",
            howWasThePatientAttitude: "How was the patient’s attitude?",
            howWasThePatientMood: "How was the patient’s mood?",
            howWasThePatientAffect: "How was the patient’s affect?",
            howWasThePatientSpeech: "How was the patient’s speech?",
            howWasThePatientThoughtOfProcess: "How was the patient’s thought process?",
            howWasThePatientCognition: "How was the patient’s cognition?",
            wereThereAnyInsights: "Were there any insights?",
            wasThereAnyStressorOrEvent: "Was there any stressor or event?",
            howsTheRecoveryEnvironmentGoing: "How’s the recovery environment going?",
            hasThePatientReportedAny: "Has the patient reported any?",
            whatWasTheInterventionProvided: "What was the intervention provided?",
            whatWasThePatientResponseToTheIntervention: "What was the patient’s response to the intervention?",
            whatsThePlanOrGoal: "What’s the plan or goal?",
            doesThePatientNeedContinuedLevelOfCare: "Does the patient need continued level of care?",
            writeDownAnyAdditionalNotes: "Write down any additional notes",
            noteUpdated: "Notes has been successfully updated",
            noteCreated: "Notes has been successfully created",
            savingNote: "Saving notes",
            deleteThisNote: "Delete this note",
            deleteNote: "Delete note",
            areYouSureYouWantToDelete: "Are you sure you want to delete this note?",
            noteSuccessfullyDeleted: "Note successfully deleted."
        }
    },
    screen404: {
        helmetTitle: "Summithill / Page not found",
        pageTitle: "404"
    },
};
